import { OdataManager } from '@/api/odata/odata-manager';
import { AppSettings } from '@/api/model/interfaces';

export default class AppSettingsOdata extends OdataManager<AppSettings> {}
